<template>
  <div>
    <s-text :label="label" :disabled="disabled" :readonly="readonly" ref="textPerson" v-model="prs.PrsDocumentNumber"
      :autofocus="autofocus" type="text" :number="false" :decimal="false" :date="false" :time="false" :datetime="false"
      @keyupEnter="toggleSaveData(prs.PrsDocumentNumber)" @input="nofoundPerson()" @keypress="validation($event)">
      <template v-if="!noCamera" v-slot:prepend-inner>
        <div style="margin-top:4px;">
          <v-icon style="cursor:pointer" @click="dialogCamera = true">
            mdi-camera
          </v-icon>
        </div>
      </template>
      <template v-slot:append>
        <v-icon style="cursor:pointer;margin-top:4px;" @click="dialogSearchPerson = true" v-if="disabled == false">
          mdi-magnify
        </v-icon>
      </template>
      <template v-if="!noEdit" v-slot:append-outer>
        <v-icon style="cursor:pointer;margin-top:4px;" @click="addOrEdit()" color="success darken-1" v-show="!disabled">
          {{ prs.PrsID != null && prs.PrsID != 0 ? "mdi-pencil" : "mdi-plus-circle-outline" }}
        </v-icon>
      </template>
    </s-text>

    <!--MODAL PARA BUSCAR PERSONAS-->
    <v-dialog v-if="dialogSearchPerson" v-model="dialogSearchPerson" persistent max-width="850"
      transition="dialog-bottom-transition">
      <v-card class="rounded-xl">
        <v-toolbar text dense dark color="primary">
          <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogSearchPerson = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-col lg="12">
          <s-search-person :addBirthDate="addBirthDate" :addTypeSex="addTypeSex" :typeperson="typeperson"
            :isManager="isManager" :addDriver="addDriver" @returnPerson="returnPerson($event)" />
        </v-col>
      </v-card>
    </v-dialog>
    <!--MODAL AGREGAR O EDITAR PERSONA-->
    <v-dialog v-model="dialogEditPerson" persistent max-width="550px" transition="dialog-bottom-transition">
      <s-add-person ref="textAddPerson" @personSaved="personSaved($event)" @toclose="toclose(2)"
        :predetermined="predetermined" :typeperson="typeperson" :propPerson="personEdit" :addBirthDate="addBirthDate"
        :addTypeSex="addTypeSex" :addDriver="addDriver" />
    </v-dialog>
    <!-- MODAL PARA CAMARA -->
    <v-dialog v-if="!noCamera" v-model="dialogCamera" max-width="700">
      <v-card>
        <v-col>
          <qrcode-stream @decode="onDecode" @init="onInit" />
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import Service from "@/services/General/PersonService";
import PublicRecruitmentService from "@/services/HumanResource/RecruitmentMassive/HmnPublicRecruitmentService";
import sAddPerson from "@/components/Utils/Person/sAddPerson";
import sSearchPerson from "@/components/Utils/Person/sSearchPerson";
export default {
  name: "sToolbarPerson",
  components: { sAddPerson, sSearchPerson, QrcodeStream },
  props: {
    addTypeSex: {
      type: Boolean,
      default: false,
    },
    addBirthDate: {
      type: Boolean,
      default: false,
    },
    addDriver: {
      type: Boolean,
      default: false,
    },
    defaultDocument: {
      type: String,
      default: "",
    },
    searchDefault: {
      type: Boolean,
      default: false,
    },
    value: null,
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Documento",
    },
    typeperson: {
      type: Number,
      default: 1,
    },
    isManager: {
      type: Number,
      default: 0,
    },
    isValidation: {
      type: Number,
      default: 0,
    },
    predetermined: {
      type: Boolean,
      default: false,
    },
    noCamera: {
      type: Boolean,
      default: false,
    },
    noEdit: {
      type: Boolean,
      default: false,
    },
    returnInmediately: {
      type: Boolean,
      default: false,
    },
    titleDialog: {
      type: String,
      default: "Listado de Personas Registradas",
    }
  },
  created() {
    if (this.value != null) {
      this.prs.PrsDocumentNumber = this.value;
      if (this.searchDefault) this.toggleSaveData(this.prs.PrsDocumentNumber);
    }
  },
  watch: {
    value(val) {
      this.prs.PrsID = 0;
      this.prs.PrsDocumentNumber = val;
    },
    "prs.PrsDocumentNumber"() {
      if (this.returnInmediately) {
        this.$emit("returnPerson", { PrsDocumentNumber: this.prs.PrsDocumentNumber });
        // this.$emit("input", this.prs.PrsDocumentNumber);
      };
    },
  },
  methods: {
    onDecode(result) {
      const doc = this.parseQrValue(result);
      this.prs.PrsDocumentNumber = doc;
      this.toggleSaveData(doc);
      this.dialogCamera = false;
    },
    parseQrValue(value) {
      const commaIndex = value.indexOf(',');
      return commaIndex !== -1 ? value.slice(0, commaIndex) : value;
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },
    reset() {
      this.prs = { PrsDocumentNumber: "" };
      this.personEdit = null;
      this.foundvalue = false;
      this.$emit("returnPerson", null);
    },
    clickCamera() {
      this.dialogCamera = true;
    },
    validation(evt) {
      evt = evt || window.event;
      var charCode = evt.which || evt.keyCode;

      if ((charCode >= 48 && charCode <= 57) || charCode === 44) {
        return true;
      }

      evt.preventDefault();
      return false;
    },
    personSaved(item) {
      this.prs.PrsDocumentNumber = item.GenPerson.PrsDocumentNumber;
      this.returnPerson(this.prs);
    },
    focus() {
      this.$refs.textPerson.focus();
    },
    addOrEdit() {
      if (this.prs.PrsID == null || this.prs.PrsID == 0) {
        this.$emit("returnPerson", null);
        this.nofoundPerson();
        this.dialogEditPerson = true;
      } else {
        this.personEdit = this.prs;
        this.dialogEditPerson = true;
        this.$nextTick(() => {
          this.$refs.textAddPerson.search();
        });
        // Service.getPerson(this.prs.PrsID, this.typeperson, this.$fun.getUserID()).then((r) => {
        //   console.log("DATAAAAA", r.data);
        //   this.personEdit = r.data;

        //   this.dialogEditPerson = true;
        // });
      }
    },
    returnPerson(item) {
      if (item != null)
        // this.foundvalue = true;

        this.toggleSaveData(item.PrsDocumentNumber);
      //  this.prs=item;
      this.dialogSearchPerson = false;
    },

    async toggleSaveData(value) {
      if (this.isSearching) return;
      if (!value) {
        this.$emit("returnPerson", null);
      }

      value = this.parseQrValue(value);
      this.isSearching = true;

      this.person = null;
      if (value == null) return;
      if (value.length > 3) {
        let obj = {
          TypePerson: this.typeperson,
          PrsDocumentNumber: value,
          UsrID: this.$fun.getUserID(),
          IsValidation: this.isValidation,
        };

        let foundPerson = false;

        // 1. Buscar en BD local (GenPerson / GenNaturalPerson)
        try {
          const response = await Service.personSearch(obj, this.$fun.getUserID());
          if (response.status == 200 && response.data != null && response.data.PrsID != null && response.data.PrsID !== 0) {
            this.prs = Object.assign(response.data, {});
            this.$emit("returnPerson", this.prs);
            if (response.data.StatusPerson == 2) {
              this.marker = true;
              this.color = "orange darken-2";
            } else this.marker = false;
            foundPerson = true;
            this.isSearching = false;
            return;
          }
        } catch (e) {
          console.error("Error al buscar en GenPerson:", e);
        }

        // 2. Si no existe en GenPerson, buscar primero en Postulantes de Reclutamiento Masivo
        if (!foundPerson) {
          try {
            const masivoResp = await PublicRecruitmentService.getByDocument(value, this.$fun.getUserID());
            if (masivoResp.status === 200 && masivoResp.data && masivoResp.data.PrsDocumentNumber) {
              const m = masivoResp.data;
              const fullName = `${m.NtpPaternalSurname || ""} ${m.NtpMaternalSurname || ""}, ${m.NtpName || ""}`.trim();
              const masivoPerson = {
                PrsID: 0,
                NtpID: 0,
                PrsDocumentNumber: m.PrsDocumentNumber,
                NtpName: m.NtpName,
                NtpPaternalSurname: m.NtpPaternalSurname,
                NtpMaternalSurname: m.NtpMaternalSurname,
                FullName: fullName,
                NtpFullName: fullName,
                NtpBirthDate: m.NtpBirthDate ? this.$moment(m.NtpBirthDate).format(this.$const.DateMomentFormat) : null,
                TypeSex: m.TypeSex || 1,
                PpnNumberPhone: m.PpnNumberPhone || "",
                NtpTelephone: m.PpnNumberPhone || "",
                PemEmail: m.PemEmail || "",
                PadAddress: m.PadAddress || "",
                TypePerson: 1,
              };

              this.prs = masivoPerson;
              this.personEdit = {
                ...masivoPerson,
                GenPerson: {
                  PrsDocumentNumber: masivoPerson.PrsDocumentNumber,
                  TypePersonDocument: 1,
                  NatID: 193,
                  Emails: masivoPerson.PemEmail ? [{ PemEmail: masivoPerson.PemEmail, PemIsDefault: 1 }] : [],
                  Telephones: masivoPerson.PpnNumberPhone ? [{ PpnNumberPhone: masivoPerson.PpnNumberPhone, PpnIsDefault: 1, TypePhone: 1 }] : [],
                  Addresses: masivoPerson.PadAddress ? [{ PadAddress: masivoPerson.PadAddress, PadIsDefault: 1 }] : [],
                },
              };

              this.$emit("returnPerson", this.prs);
              this.isSearching = false;
              return;
            }
          } catch (e) {
            console.error("Error al buscar en Postulantes Masivo:", e);
          }
        }

        // 3. Si no existe en Masivo, buscar en RENIEC
        if (!foundPerson) {
          try {
            const reniecResp = await Service.getReniec(value, this.$fun.getUserID());
            if (reniecResp.status === 200 && reniecResp.data && reniecResp.data.first_name) {
              const r = reniecResp.data;
              const fullName = `${r.first_last_name || ""} ${r.second_last_name || ""}, ${r.first_name || ""}`.trim();
              const reniecPerson = {
                PrsID: 0,
                NtpID: 0,
                PrsDocumentNumber: value,
                NtpName: (r.first_name || "").toUpperCase(),
                NtpPaternalSurname: (r.first_last_name || "").toUpperCase(),
                NtpMaternalSurname: (r.second_last_name || "").toUpperCase(),
                FullName: fullName.toUpperCase(),
                NtpFullName: fullName.toUpperCase(),
                NtpBirthDate: null,
                TypeSex: 1,
                TypePerson: 1,
              };

              this.prs = reniecPerson;
              this.personEdit = {
                ...reniecPerson,
                GenPerson: {
                  PrsDocumentNumber: value,
                  TypePersonDocument: 1,
                  NatID: 193,
                },
              };

              this.$emit("returnPerson", this.prs);
              this.isSearching = false;
              return;
            }
          } catch (e) {
            console.error("Error al consultar RENIEC:", e);
          }
        }

        // 4. Si no se encontró en ninguna fuente, abrir modal para registrar
        this.$emit("returnPerson", null);
        this.nofoundPerson();
        this.dialogEditPerson = true;
      }

      this.isSearching = false;
    },
    nofoundPerson() {
      this.prs.PrsID = 0;
      // this.$emit("returnPerson", null);
      this.personEdit = {
        PrsDocumentNumber: this.prs.PrsDocumentNumber,
        TypePerson: this.typeperson, // ? 12 : 222, // Consideraciones P.Natural {:typeperson="1", :dgr="2"} P.J {:typeperson="2", :dgr="22"}
        PrsID: null,
      };
      this.foundvalue = false;
    },

    toclose(typeperson) {
      this.dialogEditPerson = false;
      this.personEdit = null;
    },
  },
  data: () => ({
    isSearching: false,
    dialogCamera: false,
    dialogSearchPerson: false,
    personEdit: null,
    dialogEditPerson: false,
    dialog3: false,
    foundvalue: false,
    color: "success",
    prs: { PrsDocumentNumber: "" },
    config: {
      model: {
        PrsID: "ID",
        PrsDocumentNumber: "string",
        TypePersonDocument: "int",
      },
    },
  }),
};
</script>
